import { preventDefault } from '../../utils/dom/event'
import { BORDER_UNSET_TOP_BOTTOM } from '../../utils/constant'

import PickerColum from './PickerColumn'

export const pickerProps = {
  title: String,
  loading: Boolean,
  showToolbar: Boolean,
  cancelButtonText: String,
  confirmButtonText: String,
  allowHtml: {
    type: Boolean,
    default: true
  },
  visibleItemCount: {
    type: [Number, String],
    default: 5
  },
  itemHeight: {
    type: [Number, String],
    default: 44
  },
  swipeDuration: {
    type: [Number, String],
    default: 1000
  }
}

export default {
  name: 'picker',
  props: {
    ...pickerProps,
    defaultIndex: {
      type: [Number, String],
      default: 0
    },
    columns: {
      type: Array,
      default: () => []
    },
    valueKey: {
      type: String,
      default: 'text'
    }
  },
  render (h) {
    const itemHeight = +this.itemHeight
    const wrapHeight = itemHeight * this.visibleItemCount

    const frameStyle = {
      height: itemHeight + 'px'
    }

    const columnsStyle = {
      height: wrapHeight + 'px'
    }

    const maskStyle = {
      backgroundSize: `100% ${(wrapHeight - itemHeight) / 2}px`
    }

    return (
      <div>
        <div
          class="columns"
          style={columnsStyle}
          onTouchmove={preventDefault}
        >
          {this.genColumns()}
          <div class="picker__mask" style={maskStyle}/>
          <div
            class={[BORDER_UNSET_TOP_BOTTOM, 'picker__frame']}
            style={frameStyle}
          />
        </div>
      </div>
    )
  },
  data () {
    return {
      formattedColumns: []
    }
  },
  methods: {
    genColumns () {
      return this.formattedColumns.map((item, columnIndex) => (
        <PickerColum
          valueKey={this.valueKey}
        />
      ))
    },
    change () {
      console.log(this.columns)
    }
  }
}
